import React, { useEffect, useState } from "react";
import { fetchTasks } from "../redux/Slices/TasksSlice";
import { useDispatch, useSelector } from "react-redux";
import styles from "../Style/TaskStyles.module.css";

function CustomStatusTask({ StatusFilter }) {
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState();
  const { tasks, status, error } = useSelector((state) => state.tasksReducer);

  function catchData() {
    if (tasks?.length > 0) {
      const filtered = tasks.filter((task) => task.Status === StatusFilter);
      setFilterData(filtered);
    }
  }
  useEffect(() => {
    dispatch(fetchTasks());
  }, [dispatch]);
  console.log(filterData);

  useEffect(() => {
    if (status === "succeeded") {
      catchData();
    }
  }, [tasks]);

  if (status === "loading") {
    return (
      <div className="text-bold text-secondary p-3 rounded d-flex align-items-center justify-content-center fs-4 fw-bold">
        Loading tasks...
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="text-bold text-danger p-3 rounded d-flex align-items-center justify-content-center fs-4 fw-bold">
        Error: {error}
      </div>
    );
  }
  return (
    <>
      <div className={`${styles.Styledcontainer} container p-5`}>
        <div className="row justify-center align-items-center gap-4">
          {filterData?.map((task) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={task.id}>
              <div className={`${styles.Styledcard} card `}>
                <div className="card-body">
                  {/* Name && TaskId*/}
                  <div
                    className={`${styles.taskContainer} ${styles.taskStatus}  ${
                      task.Status === "Pending"
                        ? styles.pending
                        : task.Status === "Completed"
                        ? styles.completed
                        : ""
                    }`}
                  >
                    <h6 className={styles.taskId}>{task.id}</h6>
                    <p className={styles.taskName}>
                      <strong>{task.taskName}</strong>
                    </p>
                  </div>

                  {/* Date */}
                  <div className="d-flex justify-between">
                    <p className="">
                      <strong>Due Date</strong> {task.Date}
                    </p>
                    <p className=" ">
                      <strong>CreatedDate</strong> {task.createddate}
                    </p>
                  </div>
                  {/* Pending && Status */}
                  <div className="d-flex justify-between">
                    <p className="card-title">
                      <strong>{task.categories}</strong>
                    </p>

                    <p
                      className={`${styles.taskStatus} ${
                        task.Status === "Pending"
                          ? styles.pending
                          : task.Status === "Completed"
                          ? styles.completed
                          : ""
                      }`}
                    >
                      <strong> {task.Status}</strong>
                    </p>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default CustomStatusTask;
